// Case home page

if (window.location.pathname === "/") {
    var _paq = (window._paq = window._paq || []);
    _paq.push([
      'trackEvent',
      'Consultation de la page d’accueil',
      'Navigation vers la page d’accueil',
      '',
    ]);

    const linkRI = document.querySelector('a[href="/itineraire"]');

    if (linkRI) {
        linkRI.addEventListener('click', (event) => {
        var _paq = (window._paq = window._paq || []);
        _paq.push([
          'trackEvent',
          'Lancement d’une RI depuis la page d’accueil vs le menu "se déplacer"',
          'Clic sur le button RI depuis le menu "se déplacer"',
          '',
        ]);
      });
    }

    const linkEBoutique = document.querySelector('div.field__item a[href="/e-boutique"]');

    if (linkEBoutique) {
        linkEBoutique.addEventListener('click', (event) => {
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Achat de titre depuis la page d’acceuil vs le menu "titres et tarif"',
              'Clic sur les boutons de la section titres et tarifs de la page d’accueil',
              '',
            ]);
        });
    }

    const linkActualities = document.querySelector('a[href*="actualites"]');

    if (linkActualities) {
        linkActualities.addEventListener('click', (event) => {
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Consultation d’une actualité',
              'Navigation vers une page d’actualités depuis la page d’accueil',
              '',
            ]);
        });
    }

    const faqDetail = document.querySelector('.node--type-question-reponse.node--view-mode-teaser h2');
    if(faqDetail) {
        faqDetail.addEventListener('click', (event) => {
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Consultation de détail d’une Question/Réponse sur la page d’accueil',
              'Affichage de détail d’une Question/Réponse',
              '',
            ]);
        });   
    }

    

    const linkFAQFooter = document.querySelector('div.field--name-field-faq-lien a[href="/faq"]');

    if (linkFAQFooter) {
        linkFAQFooter.addEventListener('click', (event) => {
        var _paq = (window._paq = window._paq || []);
        _paq.push([
        'trackEvent',
        'Redirection vers la page FAQ depuis le footer',
        'Clic sur le bouton "Accéder à la FAQ" dans le footer',
        '',
        ]);
    });
    }

    const linkFAQHeader = document.querySelector('div.menu-item a[href="/faq"]');

    if (linkFAQHeader) {
        linkFAQHeader.addEventListener('click', (event) => {
        var _paq = (window._paq = window._paq || []);
        _paq.push([
        'trackEvent',
        'Redirection vers la page FAQ depuis le Header',
        'Clic sur le bouton "Aide" dans le header',
        '',
        ]);
    });
    }

}

if (window.location.href.includes("actualites")) {
    var _paq = (window._paq = window._paq || []);
    _paq.push([
      'trackEvent',
      'Consultation de la page actualités',
      'Navigation vers la page actualités',
      '',
    ]);

    const selectFilterActu = document.getElementById('edit-type-actualite');
    if(selectFilterActu) {
        selectFilterActu.addEventListener('change', (event) => {
            const selectedValue = event.target.value;
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Filtrage par type d’actualité',
              'Sélection d’un type d’actualités pour filtrage',
              'Nom de filtre ' + selectedValue,
            ]);
        });
    }

}

if (window.location.href.includes("partenaires")) {
    var _paq = (window._paq = window._paq || []);
    _paq.push([
      'trackEvent',
      'Consultation de la page partenaires',
      'Navigation vers la page Partenaires',
      '',
    ]);

    const selectFilterPartenaire = document.getElementById('edit-partenaire');
    if(selectFilterPartenaire) {
        selectFilterPartenaire.addEventListener('change', (event) => {
            const selectedValue = event.target.value;
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Sélection d’un partenaire',
              'Clic sur la liste des partenaires pour afficher ses détails',
              'Nom de partenaire ' + selectedValue,
            ]);
        });
    }

}

if (decodeURIComponent(window.location.pathname).includes("annuaire-mobilités")) {
    var _paq = (window._paq = window._paq || []);
    _paq.push([
      'trackEvent',
      'Consultation de la page annuaires de service de mobilité',
      'Navigation vers la page annuaire des services de mobilité',
      '',
    ]);

    const selectCommune = document.querySelector('select[name="search_terms"]');

    if(selectCommune) {
        selectCommune.addEventListener('change', (event) => {
            const selectedValue = event.target.value;

            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Filtrage par commune',
              'Recherche de services de mobilité par commune',
              'Commune : ' + selectedValue,
            ]);
        });
    }

    const selectTypeService = document.getElementById('edit-field-type-de-service-target-id');
    if(selectTypeService) {
        selectTypeService.addEventListener('change', (event) => {
            const selectedValue = event.target.value;

            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Filtrage par type de service',
              'Sélection d’un type de service pour filtrage',
              'Type de service : ' + selectedValue,
            ]);
        }); 
    } 

    

    const selectProfil = document.getElementById('edit-field-profils-target-id');
    if(selectProfil) {
        selectProfil.addEventListener('change', (event) => {
            const selectedValue = event.target.value;
            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Filtrage par profil',
              'Sélection d’un profil pour filtrage',
              'Profil : ' + selectedValue,
            ]);
        }); 
    } 

}

if (window.location.href.includes("faq")) {
    const selectCommune = document.querySelector('select[name="field_theme_faq_target_id"]');

    if(selectCommune) {
        selectCommune.addEventListener('change', (event) => {
            const selectedValue = event.target.value;

            var _paq = (window._paq = window._paq || []);
            _paq.push([
              'trackEvent',
              'Filtrage par thème de FAQ',
              'Sélection d’un thème FAQ pour filtrage',
              'Thème : ' + selectedValue,
            ]);
        });
    }
}
